export default "__VITE_ASSET__FnbEFLXm__"